// extracted by mini-css-extract-plugin
module.exports = {"image":"cs","image-placeholder":"ct","imagePlaceholder":"ct"};